import { useState, useEffect, useCallback } from 'react';
import { fetchProfile } from '@ego/api';
import useAuth from './useAuth';

export default function useProfile() {
  const { session } = useAuth();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback((showLoading = true) => {
    if (!session) {
      setProfile(null);
      setLoading(false);
      return Promise.resolve();
    }

    if (showLoading) setLoading(true);
    return fetchProfile()
      .then(data => setProfile(data))
      .catch(() => {
        if (showLoading) setProfile(null);
      })
      .finally(() => setLoading(false));
  }, [session]);

  useEffect(() => { void load(true); }, [load]);

  const refetch = useCallback(() => load(false), [load]);

  return { profile, loading, refetch };
}
